import React from 'react';
import { DeveloperSaleBadge } from './dev-sale-badge';
import { WixSaleBadge } from './wix-sale-badge';
import { BetaBadge } from './beta-badge';
import { WixChoiceBadge } from './wix-choice-badge';
import { BundleBadge } from './bundle-badge';
import { AppBadgesType, BundleAppType } from '@wix/app-market-services';
import { useEssentials } from '../../contexts/essentials-context';
import { AppBenefitsBadge } from './app-benefits-badge';
export function AppBadges({ appBadges, appName, showBorder = false, isInstalled, size = 'small', wixSaleSize = 'big', languageCode = 'en', maxCount = 2, }) {
    const { experiments } = useEssentials();
    const showNovemberSaleBadge = experiments?.enabled('specs.app-market.Sale') ?? false;
    const showDeveloperSaleBadge = experiments?.enabled('specs.app-market.DeveloperSaleBadge') ?? false;
    const replaceBundleBadge = Boolean(experiments?.enabled('specs.app-market.MoveBundlesToBenefits'));
    return (React.createElement(React.Fragment, null, appBadges
        .map(({ badge, bundleAppBadgePayload, discountBadgePayload }) => {
        switch (badge) {
            case AppBadgesType.BETA:
                return React.createElement(BetaBadge, { appName, showBorder, size });
            case AppBadgesType.WIX_CHOICE:
                return React.createElement(WixChoiceBadge, { showBorder, size });
            case AppBadgesType.PREMIUM_BENEFIT:
                if (replaceBundleBadge) {
                    return (React.createElement(AppBenefitsBadge, { appName, showBorder, size, isInstalled }));
                }
                return (React.createElement(BundleBadge, { isCouponTypeBundle: bundleAppBadgePayload?.appBundleType ===
                        BundleAppType.COUPON, appName, showBorder, size, isInstalled }));
            case AppBadgesType.APP_BENEFIT:
                return (React.createElement(AppBenefitsBadge, { appName, showBorder, size, isInstalled }));
            case AppBadgesType.WIX_SALE:
                if (showNovemberSaleBadge) {
                    return (React.createElement(WixSaleBadge, { amount: discountBadgePayload?.amount, size: wixSaleSize }));
                }
                return undefined;
            case AppBadgesType.DEV_SALE:
                if (showDeveloperSaleBadge) {
                    return (React.createElement(DeveloperSaleBadge, { amount: discountBadgePayload?.amount, endDate: discountBadgePayload?.endDate || undefined, languageCode: languageCode, showBorder, size }));
                }
                return undefined;
            default:
                return undefined;
        }
    })
        .slice(0, maxCount)));
}
export default AppBadges;
//# sourceMappingURL=app-badges.js.map